module.exports = __webpack_public_path__ + "img/bigsq.193b79f9.png";